import PropTypes from 'prop-types'
import React, { Component } from 'react'
import './style.scss';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { isEqual, shuffle } from 'lodash';
import classNames from 'classnames';

let canvas, context;

export class AnswersType6 extends Component {
  static propTypes = {}

  constructor(props) {
    super(props)
    this.ref = React.createRef();
    const {answers} = props;
    this.state = {
       value: {},
       variants: answers && shuffle(answers.variants || [])
    }
  }

  moveLine = (s_x, s_y, e_x, e_y) => {
    try {
      context.beginPath();
      context.setLineDash([8, 5]);
      context.moveTo(s_x, s_y);
      context.lineTo(e_x, e_y);
      context.stroke();
      context.closePath();
    } catch (error) {
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps){
    const { answers } = nextProps;
    if(!isEqual(nextProps.answers, this.props.answers)){
      const items = answers.variants || [];
      context.clearRect(0,0,canvas.width,canvas.height);
      items.forEach(item => {
        this.moveLine(item.startX, item.startY, item.endX, item.endY)
      })
      this.setState({
        value: {},
        variants: shuffle(items),
      })
    }
  }

  componentDidMount(){
    if(this.ref.current){
      canvas = this.ref.current;
      context = canvas.getContext("2d");
      const { answers } = this.props;
      const items = answers.variants || [];
      items.forEach(item => {
        this.moveLine(item.startX, item.startY, item.endX, item.endY)
      })
    }
  }

  getListStyle =(isDraggingOver) => {
    return {
      borderColor: isDraggingOver ? '#00adff' : '#D8D8D8',
    }
  }

  getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    // padding: grid * 2,
    // margin: `0 ${grid}px 0 0`,
  
    // change background colour if dragging
    // background: isDragging ? 'lightgreen' : 'white',
  
    // styles we need to apply on draggables
    ...draggableStyle,
  })


  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const {answers, onChange} = this.props;
    const items = answers.variants;
    const value = {...this.state.value}; 
    if (result.source.droppableId != result.destination.droppableId) {
      let id = result.draggableId
      const find = items.find(_i => _i._id == id);
      if(find){
        value[result.destination.droppableId] = find;
      }
      console.log("🚀 ~ file: AnswersType6.jsx ~ line 86 ~ AnswersType6 ~ result.source", result, id, find._id, value);

      if(result.source.droppableId != 'variants'){
        delete value[result.source.droppableId]
      }
      delete value['variants'];

      const ids = Object.keys(value).map(key => value[key]._id)

      this.setState({
        value,
        variants: items.filter(_i => !ids.includes(_i._id))
      })
      if(items.filter(_i => !ids.includes(_i._id)).length == 0){
        onChange(value)
      }
    }
  }

  render() {
    const {answers, isAnswer, help} = this.props;
    const { value, variants } = this.state;
    console.log("🚀 ~ file: AnswersType6.jsx ~ line 104 ~ AnswersType6 ~ render ~ value", value)
    const items = answers.variants || [];
    return (
      <div className='AnswersType6'>
        {isAnswer && <div className='blockedAnswer' />}
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="variants" direction="horizontal">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                // style={this.getListStyle(snapshot.isDraggingOver)}
                className={'blockItemAnswers'}
                {...provided.droppableProps}
              >
                {variants.map((item, index) => (
                  <Draggable key={item._id} draggableId={item._id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={this.getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                        className={'blockItemAnswer'}
                      >
                       {item.value}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
          <div className='blockAnswers'  style={{backgroundImage: `url(${answers.image})`}}>
            <canvas 
              ref={this.ref} 
              width="900" 
              height='500'
            />
            {items.map(_i => <div>
              <Droppable droppableId={_i._id} direction="horizontal">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={{
                      overflow: 'hidden',
                      position: 'absolute',
                      left: _i.startX > _i.endX ? _i.endX - 200 : _i.endX,
                      top: _i.endY - 25,
                      ...this.getListStyle(snapshot.isDraggingOver),
                    }}
                    {...provided.droppableProps}
                    className={classNames('blockItemAnswer', {
                      isTrue: isAnswer && help && value[_i._id] && value[_i._id]._id == _i._id,
                      isFalse: isAnswer && help && value[_i._id] && value[_i._id]._id != _i._id,
                    })}
                  >
                    {value[_i._id] && <Draggable draggableId={value[_i._id]._id} index={1}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={this.getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                          className={classNames('blockItemAnswer', {
                            isTrue: isAnswer && help && value[_i._id] && value[_i._id]._id == _i._id,
                            isFalse: isAnswer && help && value[_i._id] && value[_i._id]._id != _i._id,
                          })}
                        >
                          {value[_i._id].value}
                        </div>
                      )}
                    </Draggable>}
                  </div>
                )}
              </Droppable>
            </div>)}
          </div>
        </DragDropContext>
       
      </div>
    )
  }
}

export default AnswersType6


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/components/Answers/components/AnswersType6/AnswersType6.jsx